import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getDataFromLocalStorage, objectToFormData } from 'utils/helpers';
import Button from 'components/form/Button';
import RequestVerificationModal from 'pages/Common/RequestRaisedAndReceived/Common/RequestVerificationModal';
import { handleUserCreation, showSuccess } from 'store/slices';
import ResourceFormModal from 'pages/Admin/ResourceManagement/ResourceFormV2/ResourceFormModal';

const ResourceFormV2 = () => {
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);

  const userRole = getDataFromLocalStorage('user_type');
  const handleFormSubmit = (data) => {
    setFormData(data);

    if (userRole === '1') {
      handleConfirm(data);
    } else {
      setBtnLoading(false);
      setIsOpenFormModal(false);
      setIsOpenConfirmModal(true);
    }
  };
  const dispatch = useDispatch();

  const handleConfirm = async (data = formData) => {
    setBtnLoading(true);
    let finalData = objectToFormData(data);
    const response = await dispatch(handleUserCreation(finalData));
    if (response?.status === 200) {
      setIsOpenConfirmModal(false);
      setIsOpenFormModal(false);
      setFormData(null);
      dispatch(showSuccess(response?.message));
    }
    setBtnLoading(false);
  };

  return (
    <>
      {isOpenFormModal && (
        <ResourceFormModal
          onHide={() => setIsOpenFormModal(false)}
          onSubmit={handleFormSubmit}
          setBtnLoading={setBtnLoading}
          btnLoading={btnLoading}
        />
      )}

      {isOpenConfirmModal && (
        <RequestVerificationModal
          handleConfirmation={() => handleConfirm(formData)}
          onHide={() => setIsOpenConfirmModal(false)}
          title="You want to share the add user type request to super admin"
          isLoading={btnLoading}
        />
      )}
      <div>
        {['0', '1'].includes(userRole) && (
          <Button
            isSquare
            text="+ Add User"
            btnStyle="primary-dark"
            className="h-35 text-14-500 text-nowrap cps-20 cpe-20"
            onClick={() => {
              setIsOpenFormModal(true);
            }}
          />
        )}
      </div>
    </>
  );
};

export default ResourceFormV2;
